import React, { useState } from 'react';
import ButtonIcon from '../../ButtonIcon/ButtonIcon.js';
import { ChevronDownOutline } from '@olist/design-system-icons';
import { TableCell, DetailedContent } from './styles.js';

var Row = function (_a) {
    var data = _a.data, detailedContent = _a.detailedContent, columnsLength = _a.columnsLength, hasDetailedContent = _a.hasDetailedContent;
    var _b = useState((detailedContent === null || detailedContent === void 0 ? void 0 : detailedContent.opened) || false), isOpened = _b[0], toggleIsOpened = _b[1];
    var handleOpen = function () { return toggleIsOpened(!isOpened); };
    return (React.createElement(React.Fragment, null,
        React.createElement("tr", null,
            hasDetailedContent && (React.createElement(TableCell, { detailedContent: true, isOpened: isOpened, highlight: detailedContent && isOpened },
                React.createElement(ButtonIcon, { variation: "secondary", disabled: !detailedContent, icon: React.createElement(ChevronDownOutline, null), onClick: handleOpen, "aria-expanded": isOpened }))),
            data.map(function (_a) {
                var key = _a.key, value = _a.value;
                return (React.createElement(TableCell, { key: key }, value));
            })),
        detailedContent && isOpened && (React.createElement("tr", null,
            React.createElement(DetailedContent, { colSpan: columnsLength + 1 }, detailedContent.content)))));
};

export { Row as default };
